import React, { FC } from 'react'
import WelcomeLayout from '../../components/WelcomeLayout/WelcomeLayout'
import Error500 from '../../components/Error/Error500'

const ServerError: FC = () => {
	return (
		<WelcomeLayout>
			<Error500 />
		</WelcomeLayout>
	)
}

export default ServerError
